import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ArticleList from './components/ArticleList';
import ArticleDetail from './components/ArticleDetail';
import Blog from './components/blog/Blog';
import HomePage from './pages/HomePage';
import ProjectPage from './pages/ProjectPage';
import ResumePage from './pages/CVPage';
import ContactPage from './pages/ContactPage';
import AboutPage from './pages/AboutPage';

import logo from './logo.svg';
import './App.css';

function App() {
	return (
		<Router>
			<Routes>
				<Route path='/' element={<HomePage />} />
				<Route path='/blog' element={<Blog />} />
				<Route path='/projects' element={<ProjectPage />} />
				<Route path='/article/:slug' element={<ArticleDetail />} />
				<Route path='/cv' element={<ResumePage />} />
				<Route path='/contact' element={<ContactPage />} />
				<Route path='/about' element={<AboutPage />} />
			</Routes>
		</Router>
	);



//  return (
//    <div className="App">
//      <header className="App-header">
//        <img src={logo} className="App-logo" alt="logo" />
//        <p>
//          Edit <code>src/App.js</code> and save to reload.
//        </p>
//        <a
//          className="App-link"
//          href="https://reactjs.org"
//          target="_blank"
//          rel="noopener noreferrer"
//        >
//          Learn React
//        </a>
//      </header>
//    </div>
//  );
}

export default App;
